import { useState, useEffect, createContext, useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './components/Layout/Layout.jsx';
import ObjectWorkspace from './pages/Workspace/ObjectWorkspace.jsx';
import Board from './pages/Board/Board.jsx';
import RecordDetail from './pages/RecordDetail/RecordDetail.jsx';
import Cockpit from './pages/Cockpit/Cockpit.jsx';
import NewOrderTab from './pages/Cockpit/NewOrderTab.jsx';
import OrdersList from './pages/Cockpit/OrdersList.jsx';
import OrderEditor from './pages/Cockpit/OrderEditor.jsx';
import PendingOrders from './pages/Cockpit/PendingOrders.jsx';
import BlockedOrders from './pages/Cockpit/BlockedOrders.jsx';
import Reports from './pages/Cockpit/Reports.jsx';
import api from './services/api.js';
import { objectIcon, cockpitIcon } from './lib/icons.jsx';
import './styles/index.css';

const ObjectsCtx = createContext([]);
const DEFAULT_OBJ = '00000000-0000-0000-0000-000000000005'; // email_order (núcleo)

const ObjectHost = () => {
  const { id } = useParams();
  const objects = useContext(ObjectsCtx);
  const obj = objects.find((o) => o.id === id) || { id, name_singular: '', label_plural: id };
  return <ObjectWorkspace object={obj} />;
};

const OrderEditorShell = () => {
  const { id } = useParams();
  return <OrderEditor id={id} />;
};
const BoardHost = () => {
  const { id } = useParams();
  const objects = useContext(ObjectsCtx);
  const obj = objects.find((o) => o.id === id) || { id, name_singular: '', label_plural: id };
  return <Board object={obj} />;
};

const Shell = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [objects, setObjects] = useState([]);
  useEffect(() => { api.get('/objects').then((r) => setObjects(r.data || [])).catch(() => {}); }, []);

  const isCockpit = pathname.startsWith('/cockpit');
  const isDetail = pathname.startsWith('/r/');
  const objMatch = (pathname.match(/^\/[ob]\/([0-9a-f-]+)/i) || [])[1] || null;
  const activeId = isCockpit ? '__cockpit' : objMatch;
  const activeObj = objects.find((o) => o.id === activeId) || null;
  const isBoard = pathname.startsWith('/b/');
  const tabs = [
    ...objects.map((o) => ({ id: o.id, label: o.label_plural, icon: objectIcon(o.name_singular) })),
    { id: '__cockpit', label: 'Cockpit', icon: cockpitIcon() }
  ];
  const title = isCockpit ? 'Cockpit de Encomendas' : (isDetail ? 'Registo' : (activeObj ? (isBoard ? `Board ${activeObj.label_plural}` : activeObj.label_plural) : 'GenCRM'));

  return (
    <ObjectsCtx.Provider value={objects}>
      <Layout user={null} tabs={tabs} activeTab={activeId}
        onTabChange={(id) => navigate(id === '__cockpit' ? '/cockpit' : `/o/${id}`)}
        title={title} subtitle="Customer Care Farmacêutico">
        <Routes>
          <Route path="/o/:id" element={<ObjectHost />} />
          <Route path="/b/:id" element={<BoardHost />} />
          <Route path="/r/:recordId" element={<RecordDetail />} />
          <Route path="/cockpit" element={<Cockpit />}>
            <Route index element={<NewOrderTab />} />
            <Route path="orders" element={<OrdersList />} />
            <Route path="orders/:id" element={<OrderEditorShell />} />
            <Route path="pending" element={<PendingOrders />} />
            <Route path="blocked" element={<BlockedOrders />} />
            <Route path="reports" element={<Reports />} />
          </Route>
          <Route path="*" element={<Navigate to={`/o/${DEFAULT_OBJ}`} replace />} />
        </Routes>
      </Layout>
    </ObjectsCtx.Provider>
  );
};

const App = () => (
  <BrowserRouter>
    <Shell />
    <ToastContainer position="bottom-right" autoClose={5000} theme="light" />
  </BrowserRouter>
);

export default App;
